import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Login from 'src/components/Dashboard/Views/Login.vue'
import Categories from 'src/components/Dashboard/Views/Categories.vue'
import CreateCategory from 'src/components/Dashboard/Views/Category/Create.vue'
import EditCategory from 'src/components/Dashboard/Views/Category/Edit.vue'
import Templates from 'src/components/Dashboard/Views/Templates.vue'
import CreateTemplate from 'src/components/Dashboard/Views/Template/Create.vue'
import EditTemplate from 'src/components/Dashboard/Views/Template/Edit.vue'
import Memories from 'src/components/Dashboard/Views/Memories.vue'
import CreateMemories from 'src/components/Dashboard/Views/Memories/Create.vue'
import EditMemories from 'src/components/Dashboard/Views/Memories/Edit.vue'
import Albums from 'src/components/Dashboard/Views/Albums.vue'
import CreateAlbum from 'src/components/Dashboard/Views/Albums/Create.vue'
import EditAlbum from 'src/components/Dashboard/Views/Albums/Edit.vue'
import Tracks from 'src/components/Dashboard/Views/Tracks.vue'
import CreateTrack from 'src/components/Dashboard/Views/Tracks/Create.vue'
import EditTrack from 'src/components/Dashboard/Views/Tracks/Edit.vue'
import Reports from 'src/components/Dashboard/Views/Reports.vue'
import CreateReport from 'src/components/Dashboard/Views/Reports/Create.vue'
import EditReport from 'src/components/Dashboard/Views/Reports/Edit.vue'
import Preview from 'src/components/Dashboard/Views/Preview.vue'
import Icons from 'src/components/Dashboard/Views/Icons.vue'
import Logs from 'src/components/Dashboard/Views/Logs.vue'
import Finance from 'src/components/Dashboard/Views/Finance.vue'
import PushTask from 'src/components/Dashboard/Views/Push.vue'
import CreatePushTask from 'src/components/Dashboard/Views/Push/Create.vue'
import CreateFinance from 'src/components/Dashboard/Views/Finance/Create.vue'
import EditFinance from 'src/components/Dashboard/Views/Finance/Edit.vue'
import Calendar from 'src/components/Dashboard/Views/Calendar.vue'
import Auth from '../middleware/Auth'
import Viewer from "../middleware/Viewer";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',
        redirect: "/templates",
        component: DashboardLayout,
        children: [
            {
                path: 'categories',
                name: 'Categories',
                component: Categories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'categories/create',
                name: 'create-category',
                component: CreateCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'categories/:id',
                name: 'edit-category',
                component: EditCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'templates',
                name: 'Templates',
                component: Templates,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'templates/create',
                name: 'create-template',
                component: CreateTemplate,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'templates/:id',
                name: 'edit-template',
                component: EditTemplate,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'memories',
                name: 'Memories',
                component: Memories,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'memories/create',
                name: 'create-for-you',
                component: CreateMemories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'memories/:id',
                name: 'edit-for-you',
                component: EditMemories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'templates/create',
                name: 'create-template',
                component: CreateTemplate,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'templates/:id',
                name: 'edit-template',
                component: EditTemplate,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'preview',
                name: 'Preview',
                component: Preview,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'albums',
                name: 'Albums',
                component: Albums,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'albums/create',
                name: 'create-album',
                component: CreateAlbum,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'albums/:id',
                name: 'edit-album',
                component: EditAlbum,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tracks',
                name: 'Tracks',
                component: Tracks,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tracks/create',
                name: 'create-track',
                component: CreateTrack,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tracks/:id',
                name: 'edit-track',
                component: EditTrack,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'reports',
                name: 'reports',
                component: Reports,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'reports/create',
                name: 'create-report',
                component: CreateReport,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'reports/:id',
                name: 'edit-report',
                component: EditReport,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'finance',
                name: 'finance',
                component: Finance,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'push-tasks',
                name: 'push-tasks',
                component: PushTask,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'push-tasks/create',
                name: 'create-push-tasks',
                component: CreatePushTask,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'finance/create',
                name: 'create-finance',
                component: CreateFinance,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'finance/:id',
                name: 'edit-finance',
                component: EditFinance,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'logs',
                name: 'logs',
                component: Logs,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'calendar',
                name: 'Calendar',
                component: Calendar,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'icons',
                name: 'Icons',
                component: Icons,
                // meta: {
                //     middleware: [Auth]
                // },
            },
        ]
    },
    {path: '*', component: NotFound}
];

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js